import React from "react";
const DATA_ATTRIBUTE_KEY = "data-focus-key";
const KeyboardNavigatorContext = /*#__PURE__*/React.createContext();
export { DATA_ATTRIBUTE_KEY, KeyboardNavigatorContext };